import {POST} from "@net/service.js";
import $ from "@util/base";
import page from "./page"

const URL = {
    roleList: "role_list",
    details: "role_get",
    add: "role_add",
    update: "role_update",
    delete: "role_delete",
    permission: "permission_list",
    logList: "log_list",
    logDetails: "log_get",
};

const api = {
    roleList(params, succ) {
        let paramsData = {}
        if ($.isNotEmpty(params.name)) {
            paramsData.name = params.name
        }
        paramsData.page = params.page ? params.page : 1
        paramsData.pageTotal = params.size ? parseInt(params.size) : page.size
        let requestOptions = {
            path: URL.roleList,
            params: paramsData,
            isLoading: true,
            succ: succ
        }
        POST(requestOptions)
    },
    logList(params, succ) {
        let paramsData = {}
        if ($.isNotEmpty(params.name)) {
            paramsData.name = params.name
        }
        paramsData.page = params.page ? params.page : 1
        paramsData.pageTotal = params.size ? parseInt(params.size) : page.size
        let requestOptions = {
            path: URL.logList,
            params: paramsData,
            isLoading: true,
            succ: succ
        }
        POST(requestOptions)
    },
    logDetails(id, succ) {
        let requestOptions = {
            path: URL.logDetails,
            params: {id: parseInt(id)},
            isLoading: true,
            succ: succ
        }
        POST(requestOptions)
    },
    details(id, succ) {
        let requestOptions = {
            path: URL.details,
            params: {id: parseInt(id)},
            isLoading: true,
            succ: succ
        }
        POST(requestOptions)
    },
    add(params, succ) {
        let requestOptions = {
            path: URL.add,
            params: params,
            isLoading: true,
            succ: succ
        }
        POST(requestOptions)
    },
    update(id, params, succ) {
        params.id = parseInt(id)
        let requestOptions = {
            path: URL.update,
            params: params,
            isLoading: true,
            succ: succ
        }
        POST(requestOptions)
    },
    delete(id, succ) {
        let requestOptions = {
            path: URL.delete,
            params: {id: parseInt(id)},
            isLoading: true,
            succ: succ
        }
        POST(requestOptions)
    },
    permission(succ) {
        let requestOptions = {
            path: URL.permission,
            succ: val => {
                succ(val.itemList)
            }
        }
        POST(requestOptions)
    },
}

export default api